<template>
    <div>
        <section class="page-content center">
            <br>
            <br>
            <v-layout row wrap>
                <v-flex xs12 sm12 lg12>
                    <p class="total" style="font-size:25px" v-if="confirmado">{{msmTitulo}}</p>
                    <p class="total" style="color:#D64550; font-size:25px" v-else>{{msmTitulo}}</p>
                    <v-container class="resumo">
                        <p style="font-size:18px">{{msgCorpo}}</p>
                    </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 lg8 v-if="pdfSelecionado!=''">
                    <p class="total" style="font-size:25px">Minutas, Manuais e Guias</p>
                    <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
                </v-flex>
                <v-flex xs12 sm12 md12 lg4 v-if="pdfSelecionado!=''">
                    <br>
                    <br>
                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined" @click="pdfSelecionado = planoSelecionado.urlContrato" avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Contrato</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined" @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined" @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined" @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined" @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined" @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined" @click="pdfSelecionado = planoSelecionado.urlManual" avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined" @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                        </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined" @click="pdfSelecionado = planoSelecionado.urlGuia" avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined" @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar>
                            <v-list-tile-action>
                                <img src="../Content/images/pdf.png" width="30px">
                            </v-list-tile-action>
                            <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                        </v-list-tile>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 lg4 v-if="!boletoGerado">
                    <div class="planos-wrapper" style="background:none">
                        <div class="list-planos">                    
                            <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                <br>
                                <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                <br>
                                <h6 class="desconto">Adesão</h6>
                                <a @click="gerarBoleto()" class="button">Gerar Boleto</a>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 lg4 v-if="imprimir">
                    <div class="planos-wrapper" style="background:none">
                        <div class="list-planos">                    
                            <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                <br>
                                <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                                <br>
                                <h6 class="desconto">Adesão</h6>
                                <a @click="imprimirBoleto()" class="button">Imprimir Boleto</a>
                            </div>
                        </div>
                    </div>
                </v-flex>
                <v-flex xs12 sm12 lg4 v-if="confirmar">
                    <div class="planos-wrapper" style="background:none">
                        <div class="list-planos">                    
                            <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                                <br>
                                <h6 class="desconto">Adesão</h6>
                                <a @click="confirmarProposta()" class="button" v-if="company.status == 'AGUARDANDO CONFIRMAÇÃO'">Confirmar Proposta</a>
                                <p style="text-align: center; margin: 0px" v-if="company.status != 'AGUARDANDO CONFIRMAÇÃO'">Status da proposta: {{ company.status }}</p>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>  
            <br>
            <br>
            <br>
            <br> 
        </section>
        <loading :active.sync="isLoading" :can-cancel="true" color="#7593b4" :is-full-page="fullPage"></loading>
        <Snackbar ref=chamaSnackbar />
    </div>
</template>
<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { baseApiUrl, modelBoleto } from '@/global'
    export default {
        components: {Snackbar, Loading},
        data() {
            return {
                msmTitulo: 'Estamos quase lá!',
                msgCorpo: 'Para concluir a sua proposta, é necessário gerar o boleto. Para isso, basta clicar no botão abaixo e aguardar. ' ,
                confirmado: true,
                company: [],
                boletoGerado: false,
                pdfSelecionado: '',
                cidade: '',
                estado: '',
                bairro: '',
                fullPage: true,  
                isLoading: false, 
                token: '',
                idBoleto: '', 
                imprimir: false,
                nossoNumero: '',
                ipConfirm: '',
                confirmDate: '',
                confirmar: false,
            }               
        },

        mounted : function() {
            localStorage.clear()
            sessionStorage.clear()
            this.pegaParametrosUrl()
            this.carregaPlano()
        },

        methods: {
            async carregaPlano() {
                try {
                    let res = await axios.get(`${baseApiUrl}PrecoPlanos?filter={"where":{"companyId":"${this.company.id}"},"include":"plans"}`)
                    if (res.data != '') {
                        this.planoSelecionado = res.data[0].plans
                        this.pdfSelecionado = res.data[0].plans.urlMinutaContrato 
                    }
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar plano", "ERRO");
                }
            },

            async gerarBoleto() {
                this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                this.isLoading = true
                this.token = ''
                this.idBoleto = ''
                //Pegar Token
                /* try {
                    let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
                    if (res.data != '') {
                        this.token = res.data.token
                    }
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
                    this.close()                 
                } */
                //Criando data de vencimeto do boleto
                var datapagvenc = new Date();
                datapagvenc.setDate(new Date().getDate() + 3)
                //Preencher o campos do model de Boleto
                modelBoleto.pagadorDocumentoNumero = this.company.cnpj.replace(/[^\d]+/g,'')
                modelBoleto.pagadorNome = this.company.businessName.substr(0, 39)
                modelBoleto.pagadorEndereco = this.company.address.substr(0, 34) + ', ' + this.company.addressNumber
                modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
                modelBoleto.pagadorDocumentoTipo = 2
                modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
                modelBoleto.pagadorUf = this.estado 
                modelBoleto.pagadorCep = this.company.cep.replace(/[^\d]+/g,'');
                modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
                modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
                //salvando o responsibility e o valor do boleto caso seja anual
                modelBoleto.valorNominal = parseFloat(this.company.responsibility)
                modelBoleto.mensagem = 'Boleto referente ao plano empresarial'        
                modelBoleto.nsu = this.company.proposalNumber
                modelBoleto.nossoNumero = parseInt(this.company.proposalNumber +Math.floor(10 + Math.random() * 99))
                modelBoleto.seuNumero = this.company.proposalNumber +Math.floor(10 + Math.random() * 99)
                //Gerando o Boleto e pegando o ID
                try {
                    let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
                    if (res.data != '') {
                        this.idBoleto = res.data.id
                        this.imprimirBoleto()
                    }
                } catch (error) {
                    this.isLoading = false
                    this.vm = this;
                    this.vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                    this.close()                 
                }
            },

            async pegaDadosConfirmacao() {
                //coleta IP, data e hora da confirmação do cliente
                try {
                    let res = await axios.get(`https://api.ipify.org/?format=json`)
                    if (res.data != null) {
                        this.ipConfirm = res.data.ip
                    } else {
                        this.ipConfirm = '127.0.0.0'
                    }
                } catch (error) {
                    this.ipConfirm = '127.0.0.0'
                }
                this.confirmDate = new Date().toISOString()
            },
        
            async imprimirBoleto() {
                this.isLoading = true
                await this.pegaDadosConfirmacao()
                /* //Pegar Token
                try {
                    let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
                    if (res.data != '') {
                        this.token = res.data.token
                    }              
                } catch (error) {
                    this.loadingBoleto = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
                    this.close()                 
                } */
                //Baixando Boleto PDF
                try {
                    let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
                            /* Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token   */         
                            'Content-type': 'application/pdf'
                        }
                    })
                    if (res.data != null) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [res.data], 
                            {type: 'application/pdf'}
                        );
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        const link = document.createElement('a');
                        link.href = fileURL;
                        link.setAttribute('download', 'boleto.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        //Open the URL on new Window
                        window.open(fileURL);
                        if (!this.boletoGerado) {
                            this.boletoGerado = true
                            this.msmTitulo = 'Proposta confirmada com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Primavida Dental a dar andamento na proposta ao Contrato Coletivo Empresarial.'
                            this.atualizaCompany({
                                "salesmanIPConfirm": this.ipConfirm,
                                "companyIPConfirm": this.ipConfirm,
                                "salesmanConfirm": this.confirmDate,
                                "companyConfirm": this.confirmDate,
                                "boletoId": this.idBoleto,
                                "situacaoBoleto": "GERADO",
                                "nossoNumero": modelBoleto.nossoNumero,
                                "status" : "AGUARDANDO PAGAMENTO"
                            })
                        } else {
                            this.imprimir = false
                            this.msmTitulo = 'Boleto impresso com Sucesso!'
                            this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Primavida Dental a dar andamento na proposta ao Contrato Coletivo Empresarial.'  
                        }
                        this.isLoading = false      
                    }
                } catch (error) {
                    this.isLoading = false
                    this.vm = this;            
                    this.vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto, tente novamente ou entre em contato com a Primavida Dental!","ERRO");
                    this.close()                 
                }
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('?');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};
                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['cp']) {
                        await axios.get(`${baseApiUrl}Companies?filter[where][id]=${paramArray['cp']}`)
                        .then(res => {
                            if (res.data != null) {
                                this.company = res.data[0]
                                if (parseFloat(this.company.responsibility.replace(',','.')) > 0) {
                                    if (this.company.situacaoBoleto == "" || this.company.situacaoBoleto == "VENCIDO" || this.company.situacaoBoleto == undefined) {
                                        this.retornoViaCEP()
                                        this.confirmado = true
                                    } else if (this.company.situacaoBoleto == "PAGO") {
                                        this.confirmado = true
                                        this.boletoGerado = true
                                        this.msmTitulo = 'Pagamento detectado!'
                                        this.msgCorpo = 'Olá! Detectamos que você já efetuou o pagamento do boleto, entre em contato com a Primavida Dental para mais informações.'
                                    } else if(this.company.situacaoBoleto == "BAIXADO") {
                                        this.confirmado = true
                                        this.boletoGerado = true
                                        this.msmTitulo = 'Boleto Baixado!'
                                        this.msgCorpo = 'Olá! O boleto para essa proposta encontra-se baixado. Para mais informações, entre em contato com a Primavida Dental.'
                                    } else if (this.company.situacaoBoleto == "REGISTRADO" || this.company.situacaoBoleto == "GERADO") {
                                        this.msmTitulo = 'Boleto disponível!'
                                        this.msgCorpo = 'Olá! Já existe um boleto gerado para a sua proposta, clique abaixo para imprimir.'
                                        this.confirmado = true
                                        this.imprimir = true
                                        this.boletoGerado = true
                                        this.idBoleto = this.company.boletoId
                                        //this.imprimirBoleto()
                                    }
                                } else {
                                    this.boletoGerado = true
                                    this.confirmar = true
                                    this.msgCorpo = 'Para concluir a sua proposta, é necessário confirmá-la. Para isso, basta clicar no botão abaixo e aguardar.'
                                }
                            }
                            this.carregaPlano()
                        })
                        .catch(() => {
                            this.confirmado = false
                            this.msmTitulo = 'Algo deu errado na confirmação da proposta!'
                            this.msgCorpo = 'Você pode tentar confirmar novamente ou entrar em contato com a Primavida Dental.'
                        })
                    }
                }
            },

            async atualizaCompany(dadosEnvio) {
                try {
                    let res = await axios.post(`${baseApiUrl}Companies/upsertWithWhere?[where][id]=${this.company.id}`, dadosEnvio)
                    if (res.data != '')
                        this.isLoading = false
                        this.company = res.data
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto, tente novamente","ATENÇÃO")                   
                }
            },

            async retornoViaCEP() {
                if (this.company.cep != '') {
                    try {
                        let res = await axios.get(`https://viacep.com.br/ws/${this.company.cep.replace(/[^\d]+/g,'')}/json/`)
                        if (res.data != '') {
                            this.cidade = res.data.localidade
                            this.estado = res.data.uf
                            this.bairro = res.data.bairro
                            if (!this.cidade || !this.estado || !this.bairro)
                                this.retornoCEP()
                        } else {
                            var vmcep = this;
                            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                            this.cidade = ''
                            this.estado = ''
                            this.bairro = ''
                        }
                    } catch (error) {
                        vmcep = this;
                        vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                        this.cidade = ''
                        this.estado = ''
                        this.bairro = ''
                    }
                }
            },

            async retornoCEP(){
                try {
                    let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.company.cep})
                    if (res.data != '') {
                        await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${res.data.IdUf}}}`).then(res2 => {
                            this.estado = res2.data[0].prefix
                            this.cidade = res.data.Municipio
                            this.bairro = res.data.Bairro
                        })
                    }
                } catch (error) {
                    var vmcep = this;
                    vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                }
            },

            async confirmarProposta() {
                this.isLoading = true
                await this.pegaDadosConfirmacao()
                await this.atualizaCompany({
                    "salesmanIPConfirm": this.ipConfirm,
                    "companyIPConfirm": this.ipConfirm,
                    "salesmanConfirm": this.confirmDate,
                    "companyConfirm": this.confirmDate,
                    "status" : "EM VALIDAÇÃO"
                })
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("green", "Proposta confirmada com sucesso!", "INFORMAÇÃO");
            },
        }
    }
</script>

<style>
    .link {
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    
    .titulo {
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }

    .imagemcaarj {
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>